export default __webpack_public_path__ + "static/media/pencil.8399b036.svg";